import React from 'react';
import './style.m.less';

const VerticalMenu = props => {
  const { selectedKeys, onClick, menus } = props;
  return menus?.map(currentValue => (
    <ul className="vertical_ul" style={currentValue.isHidden ? { display: 'none' } : {}}>
      <div className='module_name'>{currentValue?.moduleName}</div>
      {currentValue?.children?.map(item => {
        const isCurrent = selectedKeys === item?.key; // 当前项
        return (
          <li className={`vertical_li ${isCurrent ? 'vertical_li_active' : ''}`} onClick={() => onClick?.(item)} key={item?.key}>
            {isCurrent ? item?.activeIcon : item?.icon}
            <span>{item?.label}</span>
          </li>
        );
      })}
    </ul>
  ));
};

export default VerticalMenu;
